<template>
    <div>
        <div class="remarks">
            <div class="title-warp">
                <div class="title">
                    检查意见
                </div>
                <div class="radio-group">
                    <el-radio-group v-model="formData.qualifiedSelect" style="margin-top: 10px"
                        :disabled="pageType == 'record' ? true : false" lable="检查意见" @change="setSession">
                        <el-radio :label="1">合格</el-radio>
                        <el-radio :label="2">不合格</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="check-cotent">
                <el-input v-model.trim="formData.remarks" type="textarea" :row="2" style="width: 100%" maxlength="200"
                    :disabled="pageType == 'record' ? true : false" placeholder="请输入详细检查意见" @blur="setSession"></el-input>
            </div>
        </div>
        <div class="info-detial">
            <InfoDetail ref="InfoDetail" :infoDetailData="infoDetailData" :disabled="disabled" :type="type"
                :pageType="pageType" @saveTemporaryCheck="saveTemporaryCheckFn" />
        </div>
    </div>
</template>
<script>
import InfoDetail from "./children/infoDetail.vue";

// import {
//     auditCompanyEdit,
// } from "@/api/checkShop";
import {
    getCertifyForCheck,
    saveTemporaryCheck,
    queryCheckRecordDetail
} from "@/api/shopmange";

export default {
    name: "checkShop_credentials",
    components: { InfoDetail },
    props: {
        //pageType: check 检查，record 记录
        pageType: {
            type: String,
            default: 'check'
        }
    },
    watch: {
        modeValue: {
            immediate: true,
            handler: function (value) {
                // console.log(value, "value");
            },
        },
    },
    data() {
        return {
            isRecord: false,
            formData: {
                qualifiedSelect: 0,
                remarks: '',
                shopId: ''
            },
            type: "approve", // view
            status: null,
            disabled: true,
            remarks: "",
            infoDetailData: [],
        };
    },
    methods: {
        // 获取session,回显
        getSeesion() {
            this.formData.shopId = this.$route.query.shopId;
            let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
            if (checkShopItemSession && this.pageType == 'check') {
                checkShopItemSession = JSON.parse(checkShopItemSession);
                if (checkShopItemSession.shopId == this.formData.shopId) {
                    this.formData.qualifiedSelect = checkShopItemSession.credentials.qualifiedSelect;
                    this.formData.remarks = checkShopItemSession.credentials.remarks;
                }
            }

             
        },
        // 设置缓存检查数据
        setSession() {
            this.formData.shopId = this.$route.query.shopId;
            let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
            if (checkShopItemSession) {
                checkShopItemSession = JSON.parse(checkShopItemSession);
                if (checkShopItemSession.shopId == this.formData.shopId) {
                    checkShopItemSession.credentials.qualifiedSelect = this.formData.qualifiedSelect;
                    checkShopItemSession.credentials.remarks = this.formData.remarks;
                    window.sessionStorage.setItem('checkShopItemSession', JSON.stringify(checkShopItemSession));
                }
            }
            // window.sessionStorage('checkStatus')
        },

        // 保存资质细项检查结果（临时表）
        saveTemporaryCheckFn(item) {
            let parmas = item;
            parmas.shopId = this.$route.query.shopId;
            saveTemporaryCheck(parmas, 'certify').then(res => { }).catch(err => { })
        },

        // 查询检查记录列表 检查类型  type 1-资质 2-商品 3-订单 4-售后订单
        // recordId 检查记录id
        queryCheckRecordDetailFn(params) {
            queryCheckRecordDetail(params).then(res => {
                this.infoDetailData = res.checkRecordDetails.records;
                this.formData.qualifiedSelect = res.globalQualifiedSelect;
                this.formData.remarks = res.remarks;
                this.$refs['InfoDetail'].transServiceDataToFormData(res)
            }).catch(err => {

            });
        }

    },

    mounted() {
        // 查资质详情
        const {
            type,
            shopId,
        } = this.$route.query;
        this.type = type;
        this.shopId = shopId;
        if (this.pageType == 'record') {
            // console.log('查询credentials 记录')
            this.queryCheckRecordDetailFn({ recordId: this.$route.query.recordId, type: 1 })
        } else {
            if (shopId) {
                getCertifyForCheck({ shopId: shopId }).then((res) => {
                    this.infoDetailData = res;
                    // console.log(this.infoDetailData, '-this.infoDetailData')
                    this.$refs['InfoDetail'].transServiceDataToFormData(res)
                });
                this.getSeesion()
            }
        }


    },

};
</script>
<style lang="scss" scoped>
.filedsContainer {
    display: flex;
    flex-flow: column;
    height: 100%;
    overflow-y: auto;

    .head {
        background: #ffffff;
        height: 76px;
        padding: 10px;
        line-height: 28px;
    }

    .font-tip {
        padding-left: 20px;
        font-size: 12px;
    }

    .footer {
        padding: 20px;
        background: #ffffff;
    }

    .remarks {
        background: #ffffff;
        padding: 0 0px 20px;

        .title-warp {
            display: flex;
        }

        .title {
            line-height: 30px;
            font-size: 16px;
            // width: 200px;
            //display: flex;
            // justify-content: space-between; 
        }

        .radio-group {
            margin-left: 10px;
        }
    }

    .info-detial {
        width: calc(100% - 0px);
    }

}
</style>
  